export const errorBoundary = {
  errorBoundaryAPPMessage1: "哎呀！出了点问题",
  errorBoundaryAPPMessage2: "我们正在修复它，请尽快尝试重新加载页面",

  errorBoundaryRedirect1: "哎呀！出了点问题",
  errorBoundaryRedirect2: "我们正在修复它，请单击按钮返回",

  errorBoundaryHandler1: "哎呀！出了点问题",
  errorBoundaryHandler2: "尝试重新加载此部分",

  errorBoundaryBtnReload: "重新加载",
  errorBoundaryBtnHome: "返回",
};
